import React, {createContext, useState, useContext} from 'react';


//This context provider allows the authentication status and current user to be shared across the app
export const AuthenticationStatusContext = createContext();

export const AuthenticationStatusProvider = ({children}) => {
    const [authenticationStatus, setAuthenticationStatus] = useState({});

    return (
        <AuthenticationStatusContext.Provider value={
                {
                    authenticationStatus,
                    setAuthenticationStatus
                }
        }>
            {children}
        </AuthenticationStatusContext.Provider>
    );
};

//Call this hook in any component to access the global authentication status
export const useAuthenticationStatus = () => {
    const context = useContext(AuthenticationStatusContext);
    if (context === undefined) {
        throw new Error('useAuthenticationStatus must be used within a AuthenticationStatusProvider');
    }
    return context;
};